
import { Button, Col, Form, Row } from "react-bootstrap";

import { useUser } from "../../../hooks/useUser";
// import { useSelector } from "react-redux";
import { Tabla } from "../../../components/Table/Table";
import { useEffect, useState } from "react";
import sliderIcon from "../../../assets/static/images/icons/slider-icon.png";
import { useDispatch, useSelector } from "react-redux";
import { mesasEntradaActions } from "../../../redux/MesasEntrada/actions";
import { actuacionesService } from "../../../_services/actuaciones.service";
import moment from "moment";
import { FiltroModal } from "./components/FiltroModal";
import { configuracionService } from "../../../_services/configuracion.service";
import { Eye, FileText, X } from "react-feather";
import excelIcon from "../../../assets/static/images/icons/excel-icon.png";
import Contribuyente from "./components/Contribuyente";
import Loading from "./components/Loading";
import { diffDays } from "../../../utils/utils";
import DetallesModal from "../MesaEntradasJudicial/Components/DetallesModal";
import { utils, writeFile } from "xlsx";
import Swal from "sweetalert2";
import { RecursosComercios } from "../../../constants";
import DescargarExcel from "../../../components/DescargarExcel/DescargarExcel";
import "./index.css";

const AbogadoExterno = () => {
  const { mesaExterna, fechaInicial } = useSelector((e) => e.mesasEntrada);
  const dispatch = useDispatch();

  const [values, setValues] = useState("");
  const [filter, setFilter] = useState("");
  const [showLoading, setShowLoading] = useState(true);

  const [data, setData] = useState([]);

  const [fechaInicialConfig, setFechaInicialConfig] = useState("");

  const [totalData, setTotalData] = useState(mesaExterna || []);

  const [showFiltro, setShowFiltro] = useState(false);
  const [causa, setCausa] = useState(null);

  const [show, setShow] = useState(false);
  const [details, setDetails] = useState(null);

  const user = useUser();
  // const history = useHistory();

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    dispatch(mesasEntradaActions.saveMesaExterna(totalData));
  }, [totalData]);

  useEffect(() => {
    if (fechaInicial) {
      setFechaInicialConfig(fechaInicial);
    }
  }, [fechaInicial]);

  useEffect(() => {
    if (filter === "Activos") {
      if (mesaExterna?.length) {
        getActivosData(mesaExterna);
      }
      else if (!data?.length) {
        getData(values);
      }
      else if (!totalData?.length) {
        getData(values);
      } else {
        getActivosData(totalData);
      }
    }
    else if (filter === "Plan de pagos") {
      getDataPlanPago(totalData);
    }
    else if (filter === "Todos") {
      getTodos(totalData);
    }
    else if (filter === "Sin Evaluar") {
      getDataSinValorar(totalData);
    }
    else {
      getActivosData(totalData);
    }

  }, [filter]);

  const getData = async (data) => {
    // setShowLoading(true);

    const res = await actuacionesService.actuacionesSearch({
      data: {
        ...data,
        abogado: user.abogado,
      },
      abogado: user.abogado,
      gruposId: [1, 2, 3],
      desde: moment().subtract(120, "day").format("YYYY-MM-DD")
    });

    setTotalData(res);

    if (filter === "Activos") {
      getActivosData(res);
    }
    else if (filter === "Sin Evaluar") {
      getDataSinValorar(res);
    }
    else if (filter === "Todos") {
      getTodos(res);
    }
    else if (filter === "Plan de pagos") {
      getDataPlanPago(res);
    }
    else {
      getActivosData(res);
    }

    // setShowLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (values && !Object.values(values).filter(e => e).length) {
      await getData(values);
    }
    else {
      setShowLoading(true);

      let result = [];

      if (values.nro_imponible) {
        const recursos = await actuacionesService.recursosxImp({ tipo: "I", imponible: values.nro_imponible });

        for (const prop of recursos) {
          const res = await actuacionesService.actuacionesSearch({
            data: {
              ...values,
              recurso: prop.RECURSO,
              // abogado: user.abogado,
            },
            // abogado: user.abogado,
            gruposId: [1, 2, 3],
            desde: moment().subtract(120, "day").format("YYYY-MM-DD")
          });

          if (res?.length) {
            result = result.concat(res);
          }
        }
      }
      else {
        result = await actuacionesService.actuacionesSearch({
          data: {
            ...values,
            // abogado: user.abogado,
          },
          // abogado: user.abogado,
          gruposId: [1, 2, 3],
          desde: moment().subtract(120, "day").format("YYYY-MM-DD")
        });
      }

      setTotalData(result);
      getTodos(result);

      setShowLoading(false);
    }
  };

  const getActivosData = async (data) => {
    if (data?.length && Array.isArray(data)) {
      setShowLoading(true);

      let fecha_inicial = fechaInicial;
      if (!fechaInicial) {
        const configuracion = await configuracionService.getConfiguracion({ key: "FECHA_INICIAL" });
        fecha_inicial = configuracion?.value;

        setFechaInicialConfig(fecha_inicial);
        dispatch(mesasEntradaActions.fechaInicial(fecha_inicial));
      }

      const filtered = data.filter((e) => {
        let confirmarHistorial = false;

        let historicos = e?.imponibles?.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(moment(a.fecha).format("YYYY-MM-DD")) - new Date(moment(b.fecha).format("YYYY-MM-DD")));

        if (historicos?.length) {
          const historico = historicos[historicos.length - 1];

          // if (historico?.SITUACION === "Gestión Legal" || (historico?.SITUACION === "Título Ejecutivo" || historico.titulo) && historico?.SITUACION !== "Plan de Pagos") {
          if (historico?.SITUACION !== "Plan de Pagos") {
            confirmarHistorial = new Date(historico.fecha) >= new Date(fecha_inicial);
          }
        }

        const actuaciones = e?.imponibles?.map((imp) => imp?.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

        let confirmarActuacion = false;
        if (actuaciones?.length) {
          let last = actuaciones[actuaciones.length - 1];
          confirmarActuacion = new Date(last.fecha).getTime() >= new Date(fecha_inicial).getTime();
        }

        return confirmarHistorial || confirmarActuacion;
      });

      setData(filtered);
      setShowLoading(false);
    } else {
      setData([]);
    }
  };

  const getDataSinValorar = async (data) => {
    if (data?.length && Array.isArray(data)) {
      setShowLoading(true);

      const configuracion = await configuracionService.getConfiguracion({ key: "SIN_EVALUAR" });
      const fechaSinEnvaluar = configuracion?.value;

      const filtered = data.filter((e) => {
        let historicos = e?.imponibles?.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

        const actuaciones = e?.imponibles?.map((imp) => imp?.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

        if (!historicos?.length && !actuaciones?.length) {
          return false;
        }

        let confirmarHistorial = true;
        let confirmarActuacion = true;

        if (historicos?.length) {
          const historico = historicos[historicos.length - 1];

          // if (historico?.SITUACION === "Gestión Legal" || (historico?.SITUACION === "Título Ejecutivo" || historico.titulo) && historico?.SITUACION !== "Plan de Pagos") {
          if (historico?.SITUACION !== "Plan de Pagos") {
            confirmarHistorial = new Date(historico.fecha) < new Date(fechaInicialConfig) && new Date(historico.fecha) >= new Date(fechaSinEnvaluar);
          } else {
            confirmarHistorial = false;
          }

          if (actuaciones?.length) {
            let last = actuaciones[actuaciones.length - 1];

            if (new Date(last.fecha) > new Date(historico.fecha)) {
              confirmarActuacion = true;
            } else {
              confirmarActuacion = false;
            }
          }
          else {
            confirmarActuacion = false;
          }
        }
        else if (actuaciones?.length) {
          let last = actuaciones[actuaciones.length - 1];

          if (new Date(last.fecha) < new Date(fechaInicialConfig)) {
            confirmarActuacion = new Date(last.fecha) >= new Date(fechaSinEnvaluar);
          }
        } else {
          confirmarActuacion = false;
        }

        return confirmarHistorial || confirmarActuacion;
      });

      setData(filtered);
      setShowLoading(false);
    } else {
      setData([]);
    }
  };

  const getDataPlanPago = async (data) => {
    if (data?.length && Array.isArray(data)) {
      setShowLoading(true);

      const filtered = data.filter((e) => {
        let plandepago = "";

        let historicos = e?.imponibles?.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

        if (historicos?.length) {
          const historico = historicos[historicos.length - 1];

          if (historico?.SITUACION === "Plan de Pagos") {
            //   plandepago = new Date(historico.fecha) >= new Date(fechaInicialConfig);
            plandepago = historico?.SITUACION === "Plan de Pagos";

            const actuaciones = e?.imponibles?.map((imp) => imp?.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

            if (actuaciones?.length) {
              let last = actuaciones[actuaciones.length - 1];

              plandepago = new Date(last.fecha).getTime() < new Date(historico.fecha).getTime();
            }
          }
        }

        return plandepago;
      });

      setData(filtered);
      setShowLoading(false);
    } else {
      setData([]);
    }
  };

  const getTodos = async (data) => {
    if (data?.length && Array.isArray(data)) {
      setShowLoading(true);

      const filtered = data.filter((e) => {
        let historicos = e?.imponibles?.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

        const actuaciones = e?.imponibles?.map((imp) => imp?.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

        if (!historicos?.length && !actuaciones?.length) {
          return false;
        }

        let confirmarHistorial = true;
        let confirmarActuacion = true;

        if (historicos?.length) {
          // const historico = historicos[historicos.length - 1];
          confirmarHistorial = true;

          // if (historico?.SITUACION === "Gestión Legal" || (historico?.SITUACION === "Título Ejecutivo" || historico.titulo) || historico?.SITUACION === "Plan de Pagos") {
          //   confirmarHistorial = true;
          // } else {
          //   confirmarHistorial = false;
          // }
        }
        if (actuaciones?.length) {
          confirmarActuacion = true;
        } else {
          confirmarActuacion = false;
        }

        return confirmarHistorial || confirmarActuacion;
      });

      setData(filtered);
      setShowLoading(false);
    } else {
      setData([]);
    }
  };

  const validate = (details) => {
    if (user.abogado === "A00" || user.rol === "admin") {
      return true;
    }
    else if (user.abogado !== "A00" && details.abogado === "A00") {
      Swal.fire({
        icon: "warning",
        text: "Esta en gestión legal"
      });
      return false;
    }
    else if (!details.abogado) {
      Swal.fire({
        icon: "warning",
        text: "Este inmueble no esta en gestión legal, para abonar dirigase a la web de San Nicolás"
      });
      return false;
    }
    else if (user.abogado !== details.abogado) {
      Swal.fire({
        icon: "warning",
        text: `Esta deuda esta asignado al abogado ${details.abogado}`
      });
      return false;
    } else {
      return true;
    }
  };

  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value
    });
  };

  const handleOpen = () => setShowFiltro(true);
  const handleClose = () => setShowFiltro(false);

  const handleOpenDetails = (e) => {
    const confirm = validate(e);

    if (confirm) {
      setDetails(e);
      setShow(true);
    }
  };

  const handleCloseDetails = () => {
    setDetails(null);
    setShow(false);
  };

  const handleIr = (e) => {
    const confirm = validate(e);

    if (confirm) {
      setCausa(e);
    }
  };

  const formatData = (arrayData) => {
    try {
      if (!arrayData?.length || !Array.isArray(arrayData)) {
        return [];
      }

      let res = arrayData.map((item) => {
        let fecha_inicial = null;
        let situacion = null;
        let titulo = false;
        let abogado = null;
        let actuacion = null;
        let lastHistorico = null;

        if (item?.imponibles?.length) {
          const imponibles = item.imponibles.filter(e => e?.actuaciones?.length);
          const imponible = imponibles[imponibles.length - 1];

          if (imponible?.actuaciones?.length) {
            const actuaciones = imponible.actuaciones.sort((a, b) => new Date(a?.fecha).getTime() - new Date(b?.fecha).getTime());
            actuacion = actuaciones[actuaciones.length - 1];

            fecha_inicial = actuacion.fecha;
            situacion = actuacion?.tipo_etapa?.grupo === 2 ? "Gestión Legal" : "Título Ejecutivo";
            titulo = actuacion?.tipo_etapa?.grupo === 2 ? false : true;
            abogado = actuacion.abogado;
          }

          let historicos = item?.imponibles.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(a?.fecha).getTime() - new Date(b?.fecha).getTime());

          if (historicos?.length) {
            const historico = historicos[historicos.length - 1];

            if (!actuacion || new Date(historico?.fecha) > new Date(actuacion?.fecha)) {
              actuacion = historico;
            } else {
              lastHistorico = historico;
            }

            if (!fecha_inicial || (new Date(historico.fecha) > new Date(fecha_inicial))) {
              fecha_inicial = historico.fecha;
              situacion = historico.SITUACION;
              abogado = historico.LEGAL;

              if (imponible?.actuaciones?.length) {
                const actuaciones = imponible.actuaciones.sort((a, b) => new Date(a?.fecha).getTime() - new Date(b?.fecha).getTime());
                const actuacion = actuaciones[actuaciones.length - 1];

                titulo = actuacion?.tipo_etapa?.grupo === 2 ? historico.titulo : true;
              } else {
                titulo = historico.titulo;
              }
            }
          }
        }

        let diferenciaDias = diffDays(fecha_inicial);
        const fecha_limite = moment(fecha_inicial).add(90, "days").format("DD/MM/YYYY");

        const recursos = item.imponibles?.reduce((prev, current) => {
          const repeat = prev.some((e) => e === current.RECURSO);

          return repeat ? prev : [...prev, current.RECURSO];
        }, []);

        let tipo = "";
        let recurso = "";
        if (recursos?.length) {
          recurso = recursos?.length ? recursos[recursos.length - 1] : "";
        }
        if (recurso) {
          tipo = RecursosComercios.includes(recurso) ? "comercios" : "inmuebles";
        }

        return {
          ...item,
          fecha_inicial: moment(fecha_inicial).format("DD/MM/YYYY"),
          fecha_limite,
          color_dias: diferenciaDias >= 0 ? diferenciaDias < 10 ? "tiempo-cerca" : "a-tiempo" : "vencido",
          categoria: "1 con cap contr",
          recursos,
          sin_color: new Date(fecha_inicial) < new Date(fechaInicialConfig) || filter === "Sin Evaluar",
          situacion,
          tab: filter,
          mesa: titulo ? "Judicial" : "Extrajudicial",
          abogado,
          tipo,
          recurso,
          last_imponible: actuacion.NRO_IMPONIBLE || actuacion.imponible,
          last_recurso: actuacion.RECURSO || actuacion.recurso,
          grupo: titulo ? 3 : 2,
          ubicacion: `${actuacion?.INMUEBLE?.CALLE || lastHistorico?.INMUEBLE?.CALLE || ""} ${actuacion?.INMUEBLE?.NRO || lastHistorico?.INMUEBLE?.NRO || ""}`,
          domicilio: `${actuacion?.CONTRIBUYENTE?.CALLE || lastHistorico?.CONTRIBUYENTE?.CALLE || ""} ${actuacion?.CONTRIBUYENTE?.NRO || lastHistorico?.CONTRIBUYENTE?.NRO || ""}`,
          nomenclatura: actuacion?.INMUEBLE?.NOMENCLATURA || lastHistorico?.INMUEBLE?.NOMENCLATURA,
          partida: actuacion?.NRO_IMPONIBLE || lastHistorico?.NRO_IMPONIBLE,
        };
      });

      return res;
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };

  async function exportRowData(e) {
    const confirm = validate(e);

    if (confirm) {
      let filename = `inmueble_${e.IMPONIBLE || e.NRO_IMPONIBLE}_${new Date().getTime()}.xlsx`;

      const dataList = [
        {
          "FECHA": e.fecha_inicial,
          "IMPONIBLE": e.IMPONIBLE || e.NRO_IMPONIBLE,
          "RECURSO": e.RECURSO,
          "ABOGADO": e.abogado,
          "CONTRIBUYENTE": e.apellnom,
          "SITUACIÓN ACTUAL": e.situacion,
          "UBICACIÓN DEL INMUEBLE": e.ubicacion,
          "DOMICILIO DE CORRESPONDENCIA": e.domicilio,
          "CIRCUNSCRIPCIÓN": e?.nomenclatura?.CIRC,
          "SECCIÓN": e?.nomenclatura?.SECC,
          "MANZANA": e?.nomenclatura?.MZ,
          "PARCELA": e?.nomenclatura?.PC,
        }
      ];

      let name = "Inmueble";

      let ws = utils.json_to_sheet(dataList);
      let wb = utils.book_new();
      utils.book_append_sheet(wb, ws, name);
      return await writeFile(wb, filename);
    }
  }

  function exportData(list) {
    let filename = `mesaextrajudicial_${new Date().getTime()}.xlsx`;

    const dataList = list.reduce((prev, current) => {
      let arr = [];

      if (current.imponibles?.length) {
        arr = current.imponibles.reduce((prevImps, e) => {
          if (!prevImps.some(p => (p["IMPONIBLE"] === e.IMPONIBLE || p["IMPONIBLE"] === e.NRO_IMPONIBLE) && p["RECURSO"] === e.RECURSO)) {
            let fecha = e.historico?.fecha || "";

            if (e.actuaciones?.length && !fecha) {
              const date = e.actuaciones[e.actuaciones.length - 1].fecha;

              fecha = moment(date).format("DD-MM-YYYY");
            }

            const situacion = e.historico ? e.historico?.SITUACION : "";
            const ubicacion = e.historico ? `${e.historico?.INMUEBLE?.CALLE || ""} ${e.historico?.INMUEBLE?.NRO || ""}` : "";
            const domicilio = e.historico ? `${e.historico?.CONTRIBUYENTE?.CALLE || ""} ${e.historico?.CONTRIBUYENTE?.NRO || ""}` : "";
            const nomenclatura = e.historico ? e.historico?.INMUEBLE?.NOMENCLATURA : "";

            return [
              ...prevImps,
              {
                "FECHA": fecha,
                "IMPONIBLE": e.IMPONIBLE || e.NRO_IMPONIBLE,
                "RECURSO": e.RECURSO,
                "ABOGADO": current.abogado,
                "CONTRIBUYENTE": current.apellnom,
                "SITUACIÓN ACTUAL": situacion,
                "UBICACIÓN DEL INMUEBLE": ubicacion,
                "DOMICILIO DE CORRESPONDENCIA": domicilio,
                "CIRCUNSCRIPCIÓN": nomenclatura?.CIRC,
                "SECCIÓN": nomenclatura?.SECC,
                "MANZANA": nomenclatura?.MZ,
                "PARCELA": nomenclatura?.PC,
              }
            ];
          } else {
            return prevImps;
          }
        }, []);

        return [...prev, ...arr];
      } else {
        return prev;
      }
    }, []);

    let name = "Abogados";

    return {
      dataList,
      filename,
      name
    };
  }

  const estados = {
    "a-tiempo": "Activo",
    "tiempo-cerca": "Activo",
    "vencido": "Vencido",
  };

  const columns = [
    {
      title: "CONTRIBUYENTE",
      dataIndex: "apellnom",
    },
    {
      title: "SITUACIÓN ACTUAL",
      dataIndex: "situacion",
    },
    {
      title: "UBICACIÓN DEL INMUEBLE",
      dataIndex: "ubicacion",
    },
    {
      title: "DOMICILIO DE CORRESPONDENCIA",
      dataIndex: "domicilio",
    },
    {
      title: "NOMENCLATURA CATASTRAL",
      dataIndex: "nomenclatura",
      render: (a, row) => {
        return (
          <div className="d-flex flex-column">
            <div className="d-flex" style={{ gap: 5 }}>
              <span>Circunscripción:</span>
              <span>{row?.nomenclatura?.CIRC}</span>
            </div>
            <div className="d-flex" style={{ gap: 5 }}>
              <span>Sección:</span>
              <span>{row?.nomenclatura?.SECC}</span>
            </div>
            {row?.nomenclatura?.CH && (
              <div className="d-flex" style={{ gap: 5 }}>
                <span>Chacra:</span>
                <span>{row?.nomenclatura?.CH}</span>
              </div>
            )}
            {row?.nomenclatura?.QT && (
              <div className="d-flex" style={{ gap: 5 }}>
                <span>Quinta:</span>
                <span>{row?.nomenclatura?.QT}</span>
              </div>
            )}
            {row?.nomenclatura?.FR && (
              <div className="d-flex" style={{ gap: 5 }}>
                <span>Fracción:</span>
                <span>{row?.nomenclatura?.FR}</span>
              </div>
            )}
            <div className="d-flex" style={{ gap: 5 }}>
              <span>Manzana:</span>
              <span>{row?.nomenclatura?.MZ}</span>
            </div>
            <div className="d-flex" style={{ gap: 5 }}>
              <span>Parcela:</span>
              <span>{row?.nomenclatura?.PC}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: "PARTIDA INMOBILIARIA",
      dataIndex: "partida",
    },
    {
      title: "ABOGADO",
      dataIndex: "abogado",
    },
    {
      title: "ESTADO DE CAUSA",
      dataIndex: "fecha_limite",
      render: (a, row) => {
        return (
          <div className="d-flex">
            <div className={!row.sin_color ? row.color_dias : ""}>
              {row.sin_color ? "Sin evaluar" : estados[row.color_dias]}
            </div>
          </div>
        );
      },
    },
    {
      title: "ACCION",
      dataIndex: "accion",
      render: (_, record) => {
        return (
          <div className="d-flex" style={{ gap: 10 }}>
            <div>
              <Eye size={28} color="#188ec5" className="cursor-pointer" onClick={() => handleOpenDetails(record)} />
            </div>
            <div>
              <button
                style={{ width: 32, height: 28, background: "var(--main-color)", borderRadius: 8, border: "none", color: "white" }}
                onClick={() => handleIr(record)}
              >
                Ir
              </button>
            </div>
            <div>
              <button
                style={{ width: 32, height: 28, background: "#185C37", borderRadius: 8, border: "none", }}
                onClick={() => exportRowData(record)}
              >
                <img src={excelIcon} width={24} />
              </button>
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="section-content inbox-section mesa-judicial">
      {causa ? (
        <Contribuyente causa={causa} setCausa={setCausa} />
      ) : (
        <div className="">
          <form onSubmit={handleSubmit}>
            <Row className="justify-content-center" style={{ gap: 10 }}>
              <Col sm={12} md={"auto"} className="p-0" >
                <Form.Label className="mb-2">Nombre y Apellido</Form.Label>
                <Form.Control
                  name={"nombre"}
                  placeholder={"Nombre y Apellido"}
                  onChange={handleChange}
                  style={{ width: 200 }}
                  value={values?.nombre || ""}
                />
              </Col>
              <Col sm={12} md={"auto"} className="p-0" >
                <Form.Label className="mb-2">N° de imponible</Form.Label>
                <Form.Control
                  name={"nro_imponible"}
                  placeholder={"N° de imponible"}
                  onChange={handleChange}
                  style={{ width: 200 }}
                  value={values?.nro_imponible || ""}
                />
              </Col>
              <Col sm={12} md={"auto"} className="p-0" >
                <Form.Label className="mb-2">DNI</Form.Label>
                <Form.Control
                  name={"dni"}
                  placeholder={"DNI"}
                  onChange={handleChange}
                  style={{ width: 200 }}
                  value={values?.dni || ""}
                />
              </Col>
              <Col sm={12} md={"auto"} className="p-0" >
                <Form.Label className="mb-2">Dirección</Form.Label>
                <Form.Control
                  name={"calle"}
                  placeholder={"Calle"}
                  onChange={handleChange}
                  style={{ width: 200 }}
                  value={values?.calle || ""}
                />
              </Col>
              <Col sm={12} md={"auto"} className="p-0" >
                <Form.Label className="mb-2">Altura</Form.Label>
                <Form.Control
                  name={"altura"}
                  placeholder={"Altura"}
                  onChange={handleChange}
                  style={{ width: 200 }}
                  value={values?.altura || ""}
                />
              </Col>
              <Col sm={12} md={"auto"} className="p-0 align-content-end">
                <Button
                  type="submit"
                  className="custom-button"
                  style={{ maxWidth: 90 }}
                >
                  BUSCAR
                </Button>
              </Col>
              <Col sm={12} md={"auto"} className="p-0 align-content-end">
                <Button
                  className="btn-outline"
                  style={{ padding: 10 }}
                  onClick={() => setValues("")}
                >
                  Limpiar filtros
                </Button>
              </Col>
            </Row>
          </form>

          <div className="mt-5">
            <div className="d-flex justify-content-between">
              <div className="d-flex mt-3 mb-3" style={{ gap: 10 }} >
                <div className="d-flex align-items-center">
                  <img onClick={handleOpen} src={sliderIcon} alt="slider-icon" className="cursor-pointer" style={{ width: 20, height: 20 }} />
                </div>
                <div onClick={handleOpen} className="text-sn fw-600 align-content-center cursor-pointer" style={{ fontSize: 18 }} >Filtrar</div>

                {filter && (
                  <div
                    className="d-flex p-2 justify-content-center align-items-center"
                    style={{ color: "#0477AD", background: "#C5E0FF", borderRadius: 6, gap: 5 }}
                  >
                    {filter} <X size={18} className="cursor-pointer" onClick={() => setFilter("")} />
                  </div>)
                }
              </div>
              <div className="mb-2" style={{ maxWidth: 170 }}>
                <DescargarExcel data={exportData(data)} />
              </div>
            </div>


            {showLoading ? (
              <Loading />
            ) : data?.length ? (
              <div className="data-content">
                <div className="data-table">
                  <Tabla
                    dataList={formatData(data)}
                    columns={columns}
                  // setPage={setPage}
                  // setLimit={setLimit}
                  />
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-center" style={{ marginTop: "10%" }}>
                <div
                  className="d-flex flex-column justify-content-center align-items-center contribuyente-message"
                  style={{ width: 300 }}
                >
                  <div><FileText size={80} color="#D2D2D2" style={{ strokeWidth: 0.3 }} /></div>
                  <div className="mt-4" style={{ fontSize: 16 }}>
                    Aqui apareceran los inmuebles del contribuyente relacionados
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showFiltro && <FiltroModal show={showFiltro} handleClose={handleClose} setFilter={setFilter} filter={filter} />}
      {show && <DetallesModal show={show} handleClose={handleCloseDetails} data={details} />}
    </div>
  );
};


export default AbogadoExterno;